
import Colors from "../utils/colors";

export default [
  {
    name: "Energy",
    color: [Colors["Red"], Colors["LightRed"]],
  },
  {
    name: "Materials",
    color: [Colors["yellow"], Colors["LightYellow"]],
  },
  {
    name: "Industrials",
    color: [Colors["Green"], Colors["LightGreen"]],
  },
  {
    name: "Consumer Discretionary",
    color: [Colors["Blue"], Colors["LightBlue"]],
  },
  {
    name: "Consumer Staples",
    color: [Colors["Blue"], Colors["Teal"]],
  },
  {
    name: "Health Care",
    color: [Colors["Red"], Colors["LightRed"]],
  },
  {
    name: "Financials",
    color: [Colors["yellow"], Colors["LightYellow"]],
  },
  {
    name: "Information Technology",
    color: [Colors["Green"], Colors["LightGreen"]],
  },

  {
    name: "Utilities",
    color: [Colors["Blue"], Colors["Teal"]],
  },
  {
    name: "Real Estate",
    color: [Colors["Red"], Colors["LightRed"]],
  },
];
